import { isDev } from "config/base"

export const getNodeBaseUrl = () => {
  if (isDev) {
    return "https://dev-functions.cryptobots.me"
  }
  return "https://functions.cryptobots.me"
}

type QueryParams = {
  utm_source?: string
  ref?: string
  balance?: string
  country?: string
  utm_medium?: string
  utm_campaign?: string
}
export const getQueryParamsString = (query: QueryParams = {}) => {
  const res = []
  if (query.utm_source) res.push("utm_source=" + query.utm_source)
  if (query.ref) res.push("ref=" + query.ref)
  if (query.balance) res.push("balance=" + query.balance)
  if (query.country) res.push("country=" + query.country)
  if (query.utm_medium) res.push("utm_medium=" + query.utm_medium)
  if (query.utm_campaign) res.push("utm_campaign=" + query.utm_campaign)
  return res.join("&")
}
